import React, { useState } from "react";
import "../style/dashboard.css";
import vector from "../assets/Vector.svg";
import Details from "./DetailsNew";
import CommForm from "./CommForm";
import Feedback from "../pages/feedback/Feedback";
import SavedDetails from "./SavedDetails";
import EditDetailsForm from "./EditDetailsform";
import RegistrationForm from "./RegistrationForm";

const DashStudent = ({ singleUser, setSingleUser }) => {
  const [editForm, setEditForm] = useState(false);
  const [feedback, setFeedback] = useState(Boolean(singleUser?.feedbackGiven));

  React.useEffect(() => {
    if (singleUser?.feedbackGiven !== undefined) {
      setFeedback(Boolean(singleUser.feedbackGiven));
    }
  }, [singleUser?.feedbackGiven]);

  if (!singleUser) return null;

  const isRegistered = Boolean(singleUser.day || singleUser.date || singleUser.attending);

  return (
    <>
      {!feedback ? (
        <Feedback setFeedback={setFeedback} />
      ) : editForm ? (
        <EditDetailsForm
          singleUser={singleUser}
          editForm={editForm}
          setEditForm={setEditForm}
          setSingleUser={setSingleUser}
        />
      ) : (

        <div className='dash-layer'>

          <div className='dash-super'>

            <div className='dash-mainy'>

              <Details singleUser={singleUser} setSingleUser={setSingleUser} />
              {singleUser.phone ? (
                <>
                  {!isRegistered ? (
                    <RegistrationForm
                      singleUser={singleUser}
                      setSingleUser={setSingleUser}
                    />
                  ) : (
                    <SavedDetails
                      singleUser={singleUser}
                      setSingleUser={setSingleUser}
                      editForm={editForm}
                      setEditForm={setEditForm}
                    />
                  )}

                </>
              ) : (
                <CommForm singleUser={singleUser} setSingleUser={setSingleUser} />
              )}

              <div style={{ marginLeft: "10px" }}>
                {isRegistered && (
                  <p style={{ color: "green" }}>
                    Congratulations! You have been successfully registered.
                  </p>
                )}
              </div>
            </div>
          </div>
          <img src={vector} alt='' className='dash-vector' />
        </div>
      )}
    </>
  );
};

export default DashStudent;
